<template>
  <a-affix :offset-top="140">
    <div style="width: 470px">
      <div id="extTypeTitle">{{ extType.toUpperCase() }}S</div>

      <div style="display: flex; justify-content: space-between">
        <a-select :style="dateWith" v-model:value="params.spa">
          <a-select-option key="s" value="s">Santé</a-select-option>
          <a-select-option key="p" value="p">Prévoyance</a-select-option>
          <a-select-option v-if="false" key="a" value="a">
            Autres risques
          </a-select-option>
        </a-select>

        <a-select :style="dateWith" v-model:value="params.er">
          <a-select-option key="e" value="e">En cours</a-select-option>
          <a-select-option key="r" value="r">Résiliés</a-select-option>
          <a-select-option v-if="false" key="t" value="t">
            Tout
          </a-select-option>
        </a-select>
      </div>

      <div style="margin: 20px 0">
        <!-- multiple -->
        <div>Assureurs</div>

        <a-select
          style="width: 100%"
          mode="multiple"
          placeholder="Tous les assureurs"
          v-model:value="assureurs"
          @change="assureurChange"
        >
          <a-select-option
            v-for="(assureur, k) in translate.assureurLibelle"
            :value="assureur"
            :key="k"
          >
            {{ assureur }}
          </a-select-option>
        </a-select>
      </div>

      <!-- assu or coti -->

      <template v-if="extType == 'assure'">
        Période de présence
        <a-space direction="horizontal">
          <a-date-picker
            :style="dateWith"
            v-model:value="params.assures_dates_start"
            :format="dateFormat"
          />
          <a-date-picker
            :style="dateWith"
            v-model:value="params.assures_dates_end"
            :format="dateFormat"
          />
        </a-space>
      </template>

      <template v-if="extType == 'cotisation'">
        Période de cotisations
        <a-space direction="horizontal">
          <a-date-picker
            v-model:value="params.cotisations_dates_start"
            :format="dateFormat"
          />
          <a-date-picker
            v-model:value="params.cotisations_dates_end"
            :format="dateFormat"
          />
        </a-space>
      </template>

      <a-divider></a-divider>

      <a-divider>Résultat</a-divider>

      <div id="extResult">
        <div v-if="lineCount > 0" id="lineCount">
          <a-spin v-if="loadingCount"></a-spin>
          <span v-if="!loadingCount">
            {{ lineCount }}
          </span>
        </div>

        <div v-if="lineCount == 0" id="nd">Aucune donnée</div>

        <div v-if="lineCount == 0" id="se">
          Sélectionner au moins une entreprise
        </div>

        <div style="text-align: center; padding: 20px 0">
          <a-button
            v-if="
              !!this.downloadLink == false && lineCount > 0 && !loadingCount
            "
            @click="prepareExcelFile()"
            type="ghost"
            shape="round"
          >
            Lancer la recherche
          </a-button>

          <a-button
            v-if="downloadLink"
            :href="downloadLink"
            type="primary"
            shape="round"
          >
            Télécharger
          </a-button>
        </div>

        <div class="loading_cont_line">
          <div v-if="ExtractionLoading" class="spinner">
            <div class="dot1"></div>
            <div class="dot2"></div>
          </div>
        </div>
      </div>
    </div>
  </a-affix>
</template>

<script>
export default {
  name: "ExtractionFiltre",
  props: {
    params: {
      type: Object,
      required: true,
    },
  },
  data: function () {
    return {
      dateFormat: "DD/MM/YYYY",
      dateWith: {
        width: "232px",
      },
      lineCount: 0,
      loadingCount: false,
      downloadLink: null,
      assureurs: [],
      langConfig: {
        days: ["D", "L", "M", "M", "J", "V", "S"],
        months: [
          "Janvier",
          "Février",
          "Mars",
          "Avril",
          "Mai",
          "Juin",
          "Juillet",
          "Août",
          "Septembre",
          "Octobre",
          "Novembre",
          "Décembre",
        ],
        monthsShort: [
          "janv",
          "févr",
          "mars",
          "avr",
          "mai",
          "juin",
          "juil",
          "août",
          "sept",
          "oct",
          "nov",
          "déc",
        ],
        today: "Today",
        now: "Now",
        am: "AM",
        pm: "PM",
      },
    };
  },
  watch: {
    extType(e) {
      this.resetParams();
    },
    spaEr() {
      this.prepareExcelData();
    },
    holdingsCnt() {
      this.prepareExcelData();
    },
    assureursCnt() {
      this.prepareExcelData();
    },
    "params.assures_dates_start"() {
      this.prepareExcelData();
    },
    "params.assures_dates_end"() {
      this.prepareExcelData();
    },
    "params.cotisations_dates_start"() {
      this.prepareExcelData();
    },
    "params.cotisations_dates_end"() {
      this.prepareExcelData();
    },
  },
  methods: {
    resetParams() {
      this.assureurs = [];
      this.params.spa = "s";
      this.params.er = "e";
      this.params.assures_dates_start = null;
      this.params.assures_dates_end = null;
      this.params.cotisations_dates_start = null;
      this.params.cotisations_dates_end = null;
      this.prepareExcelData();
    },
    assureurChange(_, objects) {
      this.params.assureurs = [];
      objects.map((a) => {
        this.params.assureurs.push(parseInt(a.key));
      });
    },
    prepareExcelData() {
      this.downloadLink = null;

      this.params.selected_holdings = JSON.stringify(this.params.holdings);
      this.params.selected_assureurs = JSON.stringify(this.params.assureurs);
      this.params.contract_type = this.params.spa + this.params.er;

      this.loadingCount = true;

      this.axios
        .get(
          `data/extraction/count/${this.extType}/?${new URLSearchParams(
            this.params
          )}`
        )
        .then((r) => {
          if (r.status === 200) {
            this.lineCount = r.data.count;

            setTimeout(() => {
              this.loadingCount = false;
            }, 30);
          }
        });
    },
    prepareExcelFile() {
      this.params.selected_holdings = JSON.stringify(this.params.holdings);
      this.params.selected_assureurs = JSON.stringify(this.params.assureurs);

      this.loadingCount = true;

      this.axios
        .get(
          `data/extraction/prepare/${this.extType}/?${new URLSearchParams(
            this.params
          )}`
        )
        .then((r) => {
          if (r.status === 200) {
            this.downloadLink = r.data.download_link;

            setTimeout(() => {
              this.loadingCount = false;
            }, 30);
          }
        });
    },
  },
  computed: {
    spaEr() {
      return this.params.spa + this.params.er;
    },
    holdingsCnt() {
      return this.params.holdings.length;
    },
    assureursCnt() {
      return this.params.assureurs.length;
    },
    extType() {
      if (this.$route.params.extType === undefined) return false;
      return this.$route.params.extType;
    },
    translate() {
      return this.$store.getters.translate;
    },
    download() {
      return this.$store.state.tempExtractionDown;
    },
    ExtractionLoading() {
      return this.$store.state.tempExtractionLoading;
    },
  },
};
</script>

<style>
div#nd {
  margin: auto;
  width: 200px;
  text-align: center;
  font-size: 20px;
  color: darkred;
}
div#se {
  margin: auto;
  width: 340px;
  text-align: center;
  font-size: 16px;
  margin-top: 14px;
}

div#extTypeTitle {
  font-size: 20px;
  margin: 13px 0 18px 0px;
  border-bottom: 2px solid darkred;
  padding-bottom: 8px;
}
div#extResult {
  width: 100%;
}
div#lineCount {
  font-size: 25px;
  width: fit-content;
  height: 40px;
  line-height: 40px;
  border-radius: 50px;
  border: 1px solid #00bf2f;
  text-align: center;
  margin: auto;
  font-weight: bold;
  padding: 0 10px;
}
</style>
